import { Exception } from './exception'
import './exception.less'

export * from './exception'

export default Exception
